
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import router from "@/router";
import {Getter} from "vuex-class";

@Component
export default class KeyTransit extends Vue {

    get canTransitKey(): boolean {
          return this.isTransitAuthorized && this.canDropOrGive;
    }

    get canDropOrGive(): boolean {
        return this.isKeyInitialized || this.isKeyUnarchived || (this.currentUserHasKey && !this.isKeyInRelay);
    }

    get currentUserHasKey(): boolean {
        return this.currentKey?.KeyHolding?.find((kH) => !kH.endDate)?.userId === this.currentUser?.id;
    }

    get isKeyInRelay(): boolean {
        return this.currentKey?.status === "IN_RELAY";
    }

    get isKeyInitialized(): boolean {
        return this.currentKey?.status === "CREATED";
    }

    get isKeyUnarchived(): boolean {
        return this.currentKey?.status === "UNARCHIVED";
    }

    get keyReferenceAgency(): any {
        return this.currentKey?.Relays?.find((r) => r.type === "AGENCY");
    }

    @Prop({default: {}})
    public currentKey: any;

    @Prop({default: false})
    public disabled: boolean;

    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;
    @Getter private currentUser: any;

    private transitDialog: boolean = false;
    private loadingAction: boolean = false;

    private isTransitAuthorized: boolean = false;

   @Watch("currentKey", { immediate: true, deep: true })
   public onCurrentKeyChanged(newValue: any, oldValue: any) {
     if (newValue && (newValue.id !== oldValue?.id)) {
      this.fetchRelayOptions();
    }
  }

  private async fetchRelayOptions() {
     if (this.keyReferenceAgency) {
       this.isTransitAuthorized = await this.$store.dispatch("options/readOptionValueByRelay", {
         relayId: this.keyReferenceAgency.id,
         optionTypeLabel: "isTransitAuthorized",
       });
     }
  }

    private mounted() {
        this.loadingAction = false;
        this.fetchRelayOptions();

    }

  private transitKey() {
        this.loadingAction = true;
        this.$store.dispatch("keys/transit", {
            keyId: this.currentKey.id,
            sourceUserId: this.currentUser.id,
            targetRelayId: this.keyReferenceAgency?.id,
            transitMode: this.currentKey.transitMode,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_transit",
                msg: this.$i18n?.t("alerts.key.transitSuccess", {key: this.currentKey.name,
                    relay: this.keyReferenceAgency?.name}),
            });
            this.dropKeyDone();
            this.transitDialog = false;
        }).catch(() => {
            this.$store.commit("alerts/displayError", {
                icon: "icon-picto_transit",
                msg: this.$i18n?.t("alerts.error.default"),
            });
        }).finally(() => {
            this.loadingAction = false;
        });
    }

    private dropKeyDone() {
        this.$store.dispatch("context/clearContext");
        if (this.isMobile) {
            this.$emit("reset");
        } else {
            router.push({name: "keys"});
        }
    }
}
